import { BRIEF_LIST_QUERY_KEY } from "@entities/brief/lib/constants";
import { INFLUENCER_REQUIREMENTS_LIST_QUERY_KEY } from "@entities/influencer/lib/constants";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IBriefForm } from "@shared/lib/types/brief";
import { BriefService } from "../services/brief.service";
import { setBriefByIdQueryData } from "./useGetBriefById";

export function useUpdateBriefForm(queryKey?: string[]) {
  const {
    mutate: updateForm,
    isLoading: isUpdating,
    isSuccess: isUpdated,
    error: updateFormError,
    variables,
  } = useMutation({
    mutationFn: async (data: {
      form: Partial<IBriefForm>;
      campaignName?: string;
      briefId: string;
    }) => {
      return await BriefService.updateForm(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      queryKey: BRIEF_LIST_QUERY_KEY,
      skipInvalidation: true,
    },
    onSuccess: (c, response, variables) => {
      setBriefByIdQueryData(c, variables.briefId, response);
      // c.invalidateQueries({ queryKey: BRIEF_LIST_QUERY_KEY });
      c.invalidateQueries({
        queryKey: [...INFLUENCER_REQUIREMENTS_LIST_QUERY_KEY, "facets"],
      });
      if (queryKey) {
        c.invalidateQueries({ queryKey: queryKey });
      } else {
        ToastService.success("Brief Updated Successfully");
      }
    },
  });

  return {
    updateForm,
    isUpdating,
    isUpdated,
    updateFormError,
    variables,
  };
}
